import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET_LOGIN_WORK_HISTORY, GET_PROGRESS } from "../Queries/attendence";
import { client } from "..";
import { setLoader } from "./loaderSlice";
import { fetchAllRecordsAsync } from "./Thunk/LoginThunk";
import { UPDATE_BREAK } from "../Queries/attendence";


export const updateBreakAsync = createAsyncThunk(
  'breaks/attendance', async ({ attendanceId, breakIn, breakOut }, { rejectWithValue }) => {
    try {
      const { data } = await client.mutate({
        mutation: UPDATE_BREAK,
        variables: {
          attendanceId,
          breakIn,
          breakOut
        }
      })
      return data.updateBreak?.response
    }
    catch (error) {
      return rejectWithValue(error.message)
    }
  }
)
export const getProgress = createAsyncThunk(
  "progress/GET_PROGRESS",
  async ({ id }, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await client.query({
        variables: { id },
        query: GET_PROGRESS,
        fetchPolicy: "no-cache"
      })
      return data?.progress;
    }
    catch (error) {
      console.error('falied to fetch adminattendnace', error.message);
      return rejectWithValue(error.message)
    }
    finally {
      dispatch(setLoader(false))
    }
  }
)
export const fetchAdminAttendanceAsync = createAsyncThunk(
  'attendance/fetchAdmin',
  async ({empId, fromDate, toDate }, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setLoader(true));

      const { data } = await client.query({
        query: GET_LOGIN_WORK_HISTORY,
        variables: {
          empId,
          fromDate,
          toDate,
        },
        fetchPolicy: 'no-cache',
      });

      return data?.LoginWorkHistoryResolver;
    } catch (error) {
      console.error('Failed to fetch admin attendance:', error.message);
      return rejectWithValue(error.message);
    } finally {
      dispatch(setLoader(false));
    }
  }
);

const initialState = {
  attendence: {},
  lastRecord: {},
  exit: false,
  AllRecords: [],
  adminAttendance: [],
  totalRecords: 0
};

const attendenceSlice = createSlice({
  name: "attendence",
  initialState,
  reducers: {
    setAttendence(state, action) {
      state.attendence = action.payload;
    },
    setLastRecord(state, action) {
      state.lastRecord = action.payload;
    },
    setProgress(state, action) {
      state.progress = action.payload;
    },
    setNewRecord(state, action) {
      state.progress.records.unshift(action.payload);
    },

    setCondition(state, action) {
      state.exit = action.payload;
    },
    setAllRecords(state, action) {
      state.AllRecords = action.payload
    },
    setTotalRecords(state, action) {
      state.totalRecords = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminAttendanceAsync.fulfilled, (state, action) => {
        state.adminAttendance = action.payload
      })
      .addCase(fetchAllRecordsAsync.fulfilled, (state, action) => {
        state.AllRecords = action.payload
      })
      .addCase(getProgress.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProgress.fulfilled, (state, action) => {
        state.loading = false;
        state.progress = action.payload
      })
      .addCase(getProgress.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export const { setAttendence, setLastRecord, setAllRecords, setCondition, setTotalRecords, setNewRecord } = attendenceSlice.actions;
export default attendenceSlice.reducer;
